import create from 'zustand'

type ToastType = 'success' | 'error' | 'info'

interface ToastState {
  visible: boolean
  type: ToastType
  message: string
  show: (payload: { type: ToastType; message: string; duration?: number }) => void
  hide: () => void
}

export const useToastStore = create<ToastState>((set) => ({
  visible: false,
  type: 'info',
  message: '',
  show: ({ type, message, duration = 3000 }) => {
    set({ visible: true, type, message })
    if (duration > 0) {
      setTimeout(() => set({ visible: false }), duration)
    }
  },
  hide: () => set({ visible: false })
}))